<template>
  <model-form
    ref="modelForm"
    :model="deliveryType"
    modal-type="modal"
  >
    <div class="column">
      <div class="row q-col-gutter-md items-start">
        <q-input
          v-model="deliveryType.name"
          class="col-6"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
          autofocus
        />
        <q-toggle
          v-model="deliveryType.enable"
          class="col-3 q-mt-sm"
          label="Enable"
        />
        <q-toggle
          v-model="deliveryType.availableOnline"
          class="col-3 q-mt-sm"
          label="Online"
        />
        <q-input
          v-model="deliveryType.description"
          class="col-12"
          label="Description"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
        />
      </div>
      <div
        class="row q-col-gutter-md items-start q-mt-sm"
      >
        <q-toggle
          v-model="deliveryType.hasDetails"
          class="col-6"
          label="Collect Details"
        >
          <q-tooltip>
            Enables the collection of details associated with this delivery, such as a delivery address.
          </q-tooltip>
        </q-toggle>
        <q-toggle
          v-if="deliveryType.hasDetails"
          v-model="deliveryType.requireDetails"
          class="col-6"
          label="Require Details"
        >
          <q-tooltip>
            Require details before the user can proceed with delivery.
          </q-tooltip>
        </q-toggle>
        <q-input
          v-if="deliveryType.hasDetails"
          v-model="deliveryType.detailsFieldName"
          class="col-12"
          label="Details Name"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
        >
          <q-tooltip>
            Label attached to the details collection field.
          </q-tooltip>
        </q-input>
        <q-input
          v-if="deliveryType.hasDetails"
          v-model="deliveryType.detailsMessage"
          class="col-12"
          type="textarea"
          autogrow
          label="Details Message"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
        >
          <q-tooltip>
            Brief instructions for the user. Displayed as a text field hint on the delivery details dialog for online orders.
          </q-tooltip>
        </q-input>
      </div>
    </div>
  </model-form>
</template>
<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'DeliveryTypeForm',
  components: {
    ModelForm
  },
  models: {
    deliveryType: {
      editing: true
    }
  }
}

</script>
